import {
  // type GetBillingStatusReq,
  type GetOrganizationByIdRes,
  type ListRes,
  type SaveOrganizationReq,
  type SaveOrganizationRes,
  saveOrganizationReqSchema,
} from '../entity/api/routes/organization';
import { apiRequest } from './request';

export async function getOrganizationById(id: string) {
  return apiRequest<GetOrganizationByIdRes>(`/organization/${id}`, 'GET', true);
}

export function getOrganizationsList() {
  return apiRequest<ListRes>('/organization/list', 'GET', true);
}

export async function updateOrganization(
  id: SaveOrganizationReq['params']['id'],
  data: SaveOrganizationReq['body']
) {
  const req = saveOrganizationReqSchema.parse({
    params: { id },
    query: null,
    body: data,
  });
  const res = await apiRequest<SaveOrganizationRes>(
    `/organization/${req.params.id}`,
    'PATCH',
    true,
    req.body
  );
  return res.data;
}
